<div class="container">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Werbebox anlegen</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row" *ngIf="this.tyepSelectForm.value.type == 'component_web_intro_landing_page'"
                        [formGroup]="addForm">

                        <div class="col-sm-12">
                            <div class="row marginBottom2Rem marginTop2Rem">
                                <div class="col-sm-12 imageCentre marginBottom2Rem"
                                    *ngIf="this.addForm.value.image != ''">
                                    <img style="max-width: 100%;max-height: 350px;"
                                        src="{{this.addForm.value.image.url}}" alt="">
                                </div>

                                <div class="col-sm-12">
                                    <div *ngFor="let p of imageProperties"
                                        class="centerVerticalAndHoritontal marginTop2Rem">
                                        <button mat-raised-button color="accent" (click)="openImageGallery(p)"
                                            style="margin-right:15px;">
                                            Bild auswählen</button>
                                        <button mat-raised-button color="primary" (click)="toogleImageUpload()"
                                            style="margin-right:15px;" class="margrinLeftBtn">
                                            Bild hochladen
                                        </button>
                                    </div>
                                </div>

                                <div class="col-sm-12 marginTop2Rem" *ngIf="showImageUpload">
                                    <div ngx-dropzone [accept]="'image/jpeg,image/jpg,image/png'"
                                        (change)="onSelect($event)">
                                        <ngx-dropzone-label>
                                            <div>
                                                <h3>Bild hierher ziehen</h3>
                                                <h5>ODER</h5>
                                                <button mat-raised-button color="accent">Durchsuchen</button>
                                            </div>
                                        </ngx-dropzone-label>
                                        <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview"
                                            *ngFor="let f of files" [file]="f" [removable]="true"
                                            (removed)="onRemove(f)">
                                        </ngx-dropzone-image-preview>
                                    </div>
                                </div>


                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Ausrichtung des Bildes:</mat-label>
                                        <mat-select formControlName="imageAlignMent">
                                            <mat-option *ngFor="let sortOption of boxTypes" [value]="sortOption.value"
                                                [disabled]="sortOption.state">
                                                {{sortOption.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row marginBottom2Rem">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Status:</mat-label>
                                        <mat-select formControlName="state">
                                            <mat-option *ngFor="let sortOption of states" [value]="sortOption.value"
                                                [disabled]="sortOption.state">
                                                {{sortOption.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <ckeditor [editor]="Editor" [config]="config" style="width: 100%;height: 250px;"
                                formControlName="text"></ckeditor>

                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="createAdvertsing()">Werbebox anlegen</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>